import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation ResendConfirmationEmail($userUid: String!){
        user_resend_confirmation_email(user_uid: $userUid) {
            success
        }
    }
`;

export async function resendConfirmationEmailByUserUid(userUid: string): Promise<boolean> {
    const result: FetchResult<{ user_resend_confirmation_email: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { userUid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.user_resend_confirmation_email.success;
}
